import React, { useMemo } from 'react'
import { date2DDMMMMMYYYString } from '../../../lib/textutils'
import { TDocument } from '../../types'

const DocDescription = ({
  doc
}: {
  doc?: TDocument
}) => {

  const {
    newtype,
    type_name,
    publish_nr, publish_year, publisher_name, publish_date,
    status_name,
    status_code,
    issue_year,
    issuers,
    domains,
  } = doc || {}

  // republished acts keep the base name in `newtype` ("ORDIN"), the full one is in `type_name`
  const type = type_name || newtype

  const formattedPubDate = useMemo(() => publish_date
    ? date2DDMMMMMYYYString(new Date(publish_date))
    : ''
    , [publish_date]);

  const singleIssuerNumber = issuers && issuers.length === 1
    ? ` Nr. ${issuers[0].issuer_nr}/${issue_year}`
    : ""

  const statusBadgeClass = useMemo(() => {
    switch (status_code) {
      case 'A':
      case 'I':
        return 'danger';
      case 'B':
      case 'L':
      case 'O':
      case 'v':
        return 'warning';
      case 'C':
      case 'M':
        return 'info';
      case 'V':
      case 'P':
      case 'R':
      case 'r':
        return 'success';
      default:
        return 'secondary';
    }
  }, [status_code]);

  if (!doc) return null;

  return (
    <div className={`container lintui-panel-content row`} style={{ marginLeft: 'unset', marginRight: 'unset' }}>
      <div className={`lintui-panel-content-inner col-md-6`} style={{ height: 'unset' }}>
        <strong>{type}</strong> {singleIssuerNumber}
      </div>
      <div className={`lintui-panel-content-inner col-md-6`} style={{ height: 'unset' }}>
        <div className={`badge ml-1 mt-1 badge-pill badge-${statusBadgeClass}`}>{status_name}</div>
      </div>

      <div className={`lintui-panel-content-inner col-md-6`} style={{ height: 'unset' }}>
        <p>Emitent: {`${issuers?.map(i => i.issuer_name.toUpperCase()).join(',')}`}</p>
        <p>Domenii: {`${domains?.map(i => i.domain_name.toUpperCase()).join(',')}`}</p>
      </div>
      <div className={`lintui-panel-content-inner col-md-6`} style={{ height: 'unset' }}>
        {(`${(publisher_name || '').toUpperCase() === 'MONITORUL OFICIAL' ? 'M.O' : publisher_name}`).toUpperCase()} nr. {publish_nr}/{publish_year} din {formattedPubDate}
      </div>
    </div>
  )
}
export default DocDescription
